import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import { fetchBlogs } from '../utils/apiService';

// Fallback Image
import imgBlogone from '../assets/image/img-8.jpg';

const Bloglist = () => {
    const [blogs, setBlogs] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useLayoutEffect(() => {
        // Trigger animations for this section
        const timer = setTimeout(() => {
            if (window.animationText) window.animationText();
            if (window.scrollingEffect) window.scrollingEffect();
            if (window.animateImgItem) window.animateImgItem();

            // Refresh ScrollTrigger as content might have changed
            if (window.ScrollTrigger) {
                window.ScrollTrigger.refresh();
            }
        }, 800);

        return () => {
            clearTimeout(timer);
            if (window.revertAnimations) window.revertAnimations();
            if (window.revertHeadline) window.revertHeadline();
        };
    }, [blogs]);

    useEffect(() => {
        const getBlogs = async () => {
            setIsLoading(true);
            const result = await fetchBlogs();
            if (result && result.status && result.data) {
                setBlogs(result.data);
            }
            setIsLoading(false);
        };
        getBlogs();
    }, []);

    const getImageUrl = (imgVal) => {
        if (!imgVal) return imgBlogone; // Fallback
        const imgStr = imgVal.toString().trim();
        return imgStr.startsWith('http')
            ? imgStr
            : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
    };

    return (
        <div className="wrapper position-relative">
            <Header />
            <div className="page-title">
                <div className="tf-container">
                    <div className="page-title-content text-center">
                        <h1
                            className="title ml-11"
                            dangerouslySetInnerHTML={{ __html: '<span class="split-text effect-right">Blog List</span>' }}
                        />
                        <div className="breadkcum">
                            <Link to="/" className="link-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" dangerouslySetInnerHTML={{ __html: 'Home' }} />
                            </Link>
                            <span className="dot"></span>
                            <span className="page-breadkcum body-2 fw-7">
                                <span className="split-text effect-right" style={{ color: 'var(--primary)' }} dangerouslySetInnerHTML={{ __html: 'Blog List' }} />
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-content">
                <div className="list-post-gird tf-spacing-2">
                    <div className="tf-container">
                        <div className="row rg-30">
                            <div className="col-xl-12">
                                <div className="row loadmore-item">
                                    {isLoading ? (
                                        <div className="col-12 text-center py-5">
                                            <p>Loading blogs...</p>
                                        </div>
                                    ) : blogs.length === 0 ? (
                                        <div className="col-12 text-center py-5">
                                            <p>No blogs available.</p>
                                        </div>
                                    ) : (
                                        blogs.map((blog) => (
                                            <div key={blog.id} className="col-lg-6 col-md-6 pb-20">
                                                <div className="tf-post-grid hover-image ">
                                                    <div className="top">
                                                        <Link to={`/blog/${blog.slug}`} className="image">
                                                            <img
                                                                src={getImageUrl(blog.image)}
                                                                data-src={getImageUrl(blog.image)}
                                                                alt={blog.title}
                                                                className="ls-is-cached lazyloaded"
                                                            />
                                                        </Link>
                                                        <div className="post-content px-md-15">
                                                            <h6
                                                                className="title lh-32"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: `<a href="/blog/${blog.slug}" class="line-clamp-3">${blog.title}</a>`
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="bottom-item px-md-15">
                                                        <i className="icon-calendar"></i>
                                                        <span>{formatDate(blog.created_at)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Bloglist;
